import * as Cookie from 'js-cookie';
import { forEach, get, isEqual, values } from 'lodash';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { LOCATION_CHANGED } from 'redux-little-router';
import { getType } from 'typesafe-actions';

import { Action } from '../../actions';
import { CLICK_PREVIEW_LINK } from '../../actions/bannerCreativePreviewPopup';
import { SHOW_BANNER_IMAGE_CANVAS } from '../../actions/banners-edit/banner-image';
import {
    ON_ACCEPT_BULK_IMAGE_REPLACEMENT,
    SELECT_IMAGE_CANVAS_IDS
} from '../../actions/banners-edit/banner-text-image';
import {
    ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    ACCEPT_MASS_ACTIONS_CALLOUTS,
    ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
    ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE,
    ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
    ON_OPEN_MASS_ACTIONS_CALLOUTS,
    ON_OPEN_MASS_ACTIONS_COUNTERS,
    ON_OPEN_MASS_ACTIONS_PIXEL,
    ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR,
    OPEN_MASS_ACTIONS_BANNERS_PRICE,
    OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR
} from '../../actions/banners-edit/banners-edit-mass-actions';
import { COPY_BANNER, COPY_PREV_BANNER, UPDATE_BANNERS_FOR_EDIT } from '../../actions/bannersEdit';
import {
    CHANGE_BANNERS_TEXT_SUBSTITUTION_FLAG,
    CHANGE_CONSIDER_COMPETITORS_FLAG,
    CHANGE_SHOW_YANDEX_CATALOG_INFO_FLAG,
    DAILY_BUDGET_OPERATIONS_METRIKA,
    GET_DEFAULT_CAMPAIGNS_FOR_EDIT,
    SEND_CREATE_CAMPAIGN_METRIKA_EVENT
} from '../../actions/campaignsEdit';
import { FREELANCER_INFO_PANEL_CLICKED } from '../../actions/clientFreelancerData';
import { PROCESS_SIDEBAR_CLICK, ProcessSidebarClick } from '../../actions/common';
import {
    OPEN_CREATIVE_CONSTRUCTOR,
    OPEN_CREATIVE_CONSTRUCTOR_PRESETS,
    OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR,
    OPEN_CREATIVE_HTML5_CONSTRUCTOR,
    OPEN_CREATIVE_IDEAS,
    UPDATE_BANNER_CREATIVE_ID
} from '../../actions/creative';
import { ACCEPT_REJECT_DEALS, OPEN_DEAL_INSPECTOR, UPDATE_DEALS } from '../../actions/deals';
import { OPEN_FREELANCER_FEEDBACK_FORM } from '../../actions/freelancers/feedback-form';
import { REQUEST_COOP_BY_CUSTOMER_START } from '../../actions/freelancers/freelancer-accept-popup';
import {
    ACKNOWLEDGE_USER_STAYED_ON_CARD,
    FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT,
    FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE,
    OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT,
    SHOW_FREELANCER_CONTACTS
} from '../../actions/freelancers/freelancer-card';
import { ADD_FREELANCER_FEEDBACK_START } from '../../actions/freelancers/freelancer-feedback';
import {
    CHANGE_COLUMNS_GRID_ORDER,
    CHANGE_COLUMNS_GRID_VISIBILITY,
    FETCH_TOOLTIP_DATA,
    FIRE_GRID_SCREEN_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT,
    FIRE_SHOW_GRID_SCREEN_RECOMMENDATION_EVENT,
    OPEN_EDIT_CAMPAIGN_POPUP,
    OPEN_EDIT_GROUPS_POPUP,
    OPEN_GRID_SCREEN_RECOMMENDATIONS_POPUP,
    RENDER_ON_FINISHED,
    SUBMIT_GRID_SCREEN_RECOMMENDATION_ITEM,
    SWITCH_TO_OLD_INTERFACE,
    TOGGLE_COMPACT_VIEW,
    UPDATE_ADDITIONAL_FILTER,
    UPDATE_CALC_TYPE_FILTER,
    UPDATE_GRID_SELECTION
} from '../../actions/grid-screen';
import { OPEN_PRICES_WIZARD } from '../../actions/grid-wizards';
import { SAVE_PHRASES_SELECTOR_PHRASES, UPDATE_DATA_FOR_EDIT_GROUPS } from '../../actions/groupsEdit';
import { FIRE_COMMON_WALLET_CLICK, UPDATE_HEADER_INFO } from '../../actions/header';
import { OPEN_HELP } from '../../actions/help';
import { KeywordsEditorActionType } from '../../actions/keywordsEditor';
import { CHANGE_COLUMNS_LOG_ORDER, CHANGE_COLUMNS_LOG_VISIBILITY } from '../../actions/log';
import { cancelModerationMessage, confirmModerationMessage, showModerationMessage } from '../../actions/messages';
import {
    PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA,
    PHRASES_SELECTOR_KEYWORD_ADD_METRICA,
    PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA,
    PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT,
    PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA,
    PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA,
    PHRASES_SELECTOR_OPEN_EDITOR,
    PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA,
    PHRASES_SELECTOR_SAVE_PHRASES,
    PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA
} from '../../actions/phrases-selector';
import { PHRASES_GENERATOR_GENERATE_PHRASES } from '../../actions/phrases-selector/generator';
import {
    PHRASES_SELECTOR_CLEAR_KEYWORDS,
    PHRASES_SELECTOR_CLEAR_MINUS_PHRASES,
    PHRASES_SELECTOR_REFINE_KEYWORD
} from '../../actions/phrases-selector/persistentData';
import { OPEN_PHRASES_SELECTOR_WIZARD } from '../../actions/phrasesSelectorWizard';
import {
    FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT,
    FIRE_SHOW_RECOMMENDATION_CARD_EVENT,
    NO_RECOMMENDATIONS_ERROR_SHOWN,
    OPEN_RECOMMENDATIONS_SCREEN,
    SUBMIT_RECOMMENDATION_CARD
} from '../../actions/recommendations';
import {
    OPEN_RECOMMENDATIONS_GRID_PAGE,
    SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM,
    SUBMIT_RECOMMENDATIONS_GRID_SUMMARY
} from '../../actions/recommendations-grid';
import { TOOL_CLICK_METRIKA } from '../../actions/tools';
import {
    OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA,
    OPEN_TURBOLANDINGS_CONSTRUCTOR,
    UPDATE_TURBOLANDING
} from '../../actions/turbolandings';
import {
    OPEN_VIDEO_CONSTRUCTOR,
    OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO,
    UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID,
    UPDATE_BANNER_VIDEO_CREATIVE_ID
} from '../../actions/video';
import {
    BASE_USER_SETTINGS_SUBMITTED_METRIKA,
    CREATE_FIRST_CAMPAIGN,
    WELCOME_BANNER_IS_CLICKED,
    WELCOME_BANNER_IS_SHOWN
} from '../../actions/welcome-screen';
import { ToolKey } from '../../declarations/tools/tools';
import { mapCampaignTypeToCalcType } from '../../mappers/filter/filter';
import { RoutesPath } from '../../routes/index';
import { getCampaignValue } from '../../selectors/campaignsEdit/campaignsEdit';
import {
    selectCalcTypeForMetrika,
    selectGridAdditionalFilterForMetrika,
    selectGridCompactViewForMetrika,
    selectGridFilterExpressionsForMetrika,
    selectGridSourceParamsViewForMetrika,
    selectSelectionForMetrika,
    selectSortParamsForMetrika,
    selectStatPeriodValueForMetrika
} from '../../selectors/metrika';
import { CanvasPageType } from '../../typings/banners';
import { EditCampaignData, EditCampaignValueField } from '../../typings/campaignsEdit';
import {
    banners,
    campaigns,
    ColumnsSettings,
    ColumnsSettingsViewDict,
    ColumnViewInfo,
    groups,
    TurboCreationMode
} from '../../typings/common';
import { RegionCode } from '../../typings/constants';
import { DealsUpdateObject } from '../../typings/deals';
import { CampaignType, GroupType } from '../../typings/domain';
import { FreelancerFeedbackFormModes, FreelancerInfoPanelClickTypes } from '../../typings/freelancers';
import { GdMenuItem } from '../../typings/graphql-grid';
import { GridAction } from '../../typings/grid';
import { KeywordsEditorDataTabs } from '../../typings/keywordsEditorData';
import { PhrasesSelectorWizardId } from '../../typings/phrases';
import { RecommendationType } from '../../typings/recommendations';
import { State } from '../../typings/state';
import { DnaStrategyType } from '../../typings/strategy';
import { WelcomeBannerType } from '../../typings/welcome';
import { captureException } from '../ErrorsReporting/ErrorsReporting';

import { metrikaApi, MetrikaCounter } from './metrikaApi';

const turbolandingConstructorCreationModeMap = {
    [TurboCreationMode.LIBRARY]: 'library',
    [TurboCreationMode.TEMPLATE]: 'templates',
    [TurboCreationMode.WIZARD]: 'fast'
};

function getYandexUidCookie(): string | undefined {
    return Cookie.get('yandexuid');
}

export function fireBannersEditMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            editBanners: data
        }
    });
}

export function fireGroupsEditMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            editGroups: data
        }
    });
}

export function fireCampaignsEditMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            editCampaigns: data
        }
    });
}

export function fireRegionsMassEditMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            regionsMassEdit: data
        }
    });
}

export function fireMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            grid: data
        }
    });
}

export function fireHeaderMetrika(data: {}): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            header: data
        }
    });
}

export function reachGoal(goalName: string, params: {} = {}): void {
    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, goalName, params);
}

export function fireGridActionParams(actionName: GridAction, selection: object): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            grid: {
                action: {
                    [actionName]: true,
                    selection
                }
            }
        }
    });
}

function fireSidebarAction(action: ProcessSidebarClick): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            sidebar: {
                click: {
                    [action.id]: true
                }
            }
        }
    });
}

function fireCompactViewAction(isCompactViewEnabled: boolean): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            grid: {
                compactView: isCompactViewEnabled ? 'yes' : 'no'
            }
        }
    });
}

function fireToolsMetrika(tool: ToolKey): void {
    metrikaApi.params(MetrikaCounter.COUNTER_34, {
        dna: {
            tools: {
                click: {
                    [tool]: true
                }
            }
        }
    });
}

// Если мы репортим в метрику данные сразу при открытии страницы
// то счетчик может не успеть подгрузиться
const metrikaInitTimeout = new Promise((resolve): number => window.setTimeout(resolve, 4000));

export const metrikaMiddleware: Middleware<{}, State, Dispatch<Action>> = (
    store: MiddlewareAPI<Dispatch<Action>, State>
): ((next: Dispatch<Action>) => (action: Action) => Action) => (
    next: Dispatch<Action>
): ((action: Action) => Action) => (action: Action): Action => {
    const oldState = store.getState();
    const result = next(action);
    const newState = store.getState();

    metrikaInitTimeout
        .then(() => processAction(oldState as State, newState as State, action))
        .catch(error => {
            captureException(error);
        });

    return result;
};

const columnsSettingsVisibilityDiff = (
    oldSettings: ColumnsSettingsViewDict,
    newSettings: ColumnsSettingsViewDict
): Record<string, boolean> => {
    const visibilityDiff = {};

    forEach(oldSettings, (settingsDict: ColumnsSettings, viewKey: string) => {
        forEach(settingsDict, (oldColumnSettings: ColumnViewInfo, columnKey: string) => {
            const newColumnSettings = get(newSettings, `${viewKey}${columnKey}`);

            if (!newColumnSettings) {
                return;
            }

            if (
                Boolean(oldColumnSettings.columnViewInfo[columnKey].hidden) !==
                Boolean(newColumnSettings.columnViewInfo[columnKey].hidden)
            ) {
                visibilityDiff[
                    `${viewKey}-${columnKey}-was-${
                        newColumnSettings.columnViewInfo[columnKey].hidden ? 'hidden' : 'shown'
                    }`
                ] = true;
            }
        });
    });

    return visibilityDiff;
};

const columnsOrderDiff = (
    oldSettings: ColumnsSettingsViewDict,
    newSettings: ColumnsSettingsViewDict
): string | {} | void => {
    let orderDiff = {};

    if (!newSettings) {
        return;
    }

    forEach(oldSettings, (settingsDict: ColumnsSettings, viewKey: string) => {
        if (!isEqual(oldSettings[viewKey].columnOrder, newSettings[viewKey].columnOrder)) {
            orderDiff = `for-${viewKey}-tab-new-order-is:-${newSettings[viewKey].columnOrder}`;
        }
    });

    return orderDiff;
};

const getChangeDataDealMetrikaCounter = (updateDeal: DealsUpdateObject): void => {
    if (updateDeal.deals.length) {
        metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CHANGE_NAME_DEAL');
    }

    if (updateDeal.add_links.length || updateDeal.remove_links.length) {
        metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'BIND_CAMPAIGNS_TO_DEAL');
    }
};

const fireMetrikaOnCreateCampaignEvent = (campaignData: EditCampaignData): void => {
    let goalId: string;

    if (campaignData.type === CampaignType.TEXT) {
        // эксперимент из DIRECT-107790 проводим только для ТГО-кампаний
        switch (campaignData.value[EditCampaignValueField.strategy].type) {
            case DnaStrategyType.OPTIMIZE_CPA:
                goalId = 'DIRECT-107790-campaign-saved-with-optimize-conversions-strategy';
                break;
            case DnaStrategyType.ROI:
                goalId = 'DIRECT-107790-campaign-saved-with-roi-strategy';
                break;
            case DnaStrategyType.OPTIMIZE_CLICKS:
                goalId = 'DIRECT-107790-campaign-saved-with-optimize-clicks-strategy';
                break;
            case DnaStrategyType.MANUAL:
            default:
                goalId = 'DIRECT-107790-campaign-saved-with-manual-strategy';
                break;
        }
        reachGoal(goalId);
    }
};

const processAction = (oldState: State, newState: State, action: Action): void => {
    processCanvasActions(oldState, newState, action);
    processModerationMessageActions(oldState, newState, action);

    switch (action.type) {
        case CLICK_PREVIEW_LINK: {
            fireBannersEditMetrika({
                clickPreviewLink: true
            });

            break;
        }

        case UPDATE_BANNERS_FOR_EDIT: {
            const { banners: bannersToUpd } = action.data;

            const types = new Set();

            const bannersList = values(bannersToUpd);
            bannersList.forEach(banner => {
                // При создании CPM групп, можно менять тип группы
                if (!banner.isNew) {
                    types.add(banner.group.type);
                }
            });

            types.forEach((groupType: GroupType) =>
                fireBannersEditMetrika({
                    groupType
                })
            );

            if (bannersList[0]) {
                const campaignType = bannersList[0].campaign.type;
                fireBannersEditMetrika({
                    calcType: mapCampaignTypeToCalcType(campaignType)
                });
            }

            break;
        }

        case UPDATE_DATA_FOR_EDIT_GROUPS: {
            // Чтобы не портить метрики
            if (action.afterSave) {
                break;
            }

            const { groups: groupsToUpd } = action.data;

            const types = new Set();

            const groupsList = values(groupsToUpd);
            groupsList.forEach(group => {
                // При создании CPC объявлений, можно менять тип баннера
                if (!group.isNew) {
                    types.add(group.value.groupType);
                }
            });

            types.forEach((groupType: GroupType) => fireGroupsEditMetrika({ groupType }));

            if (groupsList[0]) {
                const { campaignType } = groupsList[0].value;
                fireGroupsEditMetrika({
                    calcType: mapCampaignTypeToCalcType(campaignType)
                });
            }

            break;
        }

        case CHANGE_BANNERS_TEXT_SUBSTITUTION_FLAG: {
            const campaignValue = getCampaignValue(newState, action.campaignId);

            fireCampaignsEditMetrika({
                changeBannerTextSubstitution: campaignValue[EditCampaignValueField.hasBannersTextSubstitution]
            });

            break;
        }

        case CHANGE_SHOW_YANDEX_CATALOG_INFO_FLAG: {
            const campaignValue = getCampaignValue(newState, action.campaignId);

            fireCampaignsEditMetrika({
                changeShowPermalinkInfo: campaignValue[EditCampaignValueField.showYandexCatalogInfo]
            });

            break;
        }

        case CHANGE_CONSIDER_COMPETITORS_FLAG: {
            const campaignValue = getCampaignValue(newState, action.campaignId);

            fireCampaignsEditMetrika({
                changeConsiderCompetitors: campaignValue[EditCampaignValueField.considerCompetitors]
            });

            break;
        }

        case CHANGE_COLUMNS_GRID_VISIBILITY: {
            const columnsSettings = columnsSettingsVisibilityDiff(
                oldState.grid.columnsSettings,
                newState.grid.columnsSettings
            );

            fireMetrika({
                columnsSettings
            });

            break;
        }

        case CHANGE_COLUMNS_LOG_VISIBILITY: {
            const columnsSettings = columnsSettingsVisibilityDiff(
                oldState.log.columnsSettings,
                newState.log.columnsSettings
            );

            fireMetrika({
                columnsSettings
            });

            break;
        }

        case CHANGE_COLUMNS_GRID_ORDER: {
            const newGridColumnsOrder = columnsOrderDiff(oldState.grid.columnsSettings, newState.grid.columnsSettings);
            fireMetrika({
                newGridColumnsOrder
            });
            break;
        }

        case CHANGE_COLUMNS_LOG_ORDER: {
            const newLogColumnsOrder = columnsOrderDiff(oldState.log.columnsSettings, newState.log.columnsSettings);
            fireMetrika({
                newLogColumnsOrder
            });
            break;
        }

        case UPDATE_GRID_SELECTION: {
            fireMetrika(selectSelectionForMetrika(newState));

            break;
        }

        case OPEN_PRICES_WIZARD: {
            fireMetrika({
                pricesWizard: {
                    opened: true,
                    phrasesCount: newState.grid.selectionInfo.phrases.length
                }
            });

            break;
        }

        case FETCH_TOOLTIP_DATA: {
            fireMetrika({
                helpTooltip: {
                    opened: true,
                    id: action.id
                }
            });
            break;
        }
        case OPEN_HELP: {
            fireMetrika({
                helpTooltip: {
                    opened: true,
                    id: action.id
                }
            });
            break;
        }

        case UPDATE_CALC_TYPE_FILTER: {
            const oldCalcTypeFilter = selectCalcTypeForMetrika(oldState);
            const newCalcTypeFilter = selectCalcTypeForMetrika(newState);

            if (oldCalcTypeFilter && newCalcTypeFilter && oldCalcTypeFilter !== newCalcTypeFilter) {
                fireMetrika({
                    calcTypeFilter: newCalcTypeFilter
                });
            }

            break;
        }

        case RENDER_ON_FINISHED: {
            const { route } = newState.router;

            switch (route) {
                case RoutesPath.shortGrid:
                case RoutesPath.grid: {
                    const calcType = selectCalcTypeForMetrika(newState);
                    const view = selectGridSourceParamsViewForMetrika(newState);

                    fireMetrika({
                        viewWithCalcType: `${view}_${calcType}`
                    });

                    break;
                }

                default:
                    break;
            }

            break;
        }

        case UPDATE_ADDITIONAL_FILTER: {
            const oldAdditionalFilters = selectGridAdditionalFilterForMetrika(oldState);
            const newAdditionalFilters = selectGridAdditionalFilterForMetrika(newState);

            if (oldAdditionalFilters && newAdditionalFilters && oldAdditionalFilters !== newAdditionalFilters) {
                fireMetrika({
                    additionalFilters: newAdditionalFilters
                });
            }

            break;
        }

        case LOCATION_CHANGED: {
            const { route } = newState.router;

            switch (route) {
                case RoutesPath.shortGrid:
                case RoutesPath.grid: {
                    const oldView = selectGridSourceParamsViewForMetrika(oldState);
                    const newView = selectGridSourceParamsViewForMetrika(newState);

                    if (oldView !== newView) {
                        fireMetrika({
                            view: newView
                        });
                    }

                    const oldSortParams = selectSortParamsForMetrika(oldState);
                    const newSortParams = selectSortParamsForMetrika(newState);

                    if (oldSortParams && newSortParams && oldSortParams !== newSortParams) {
                        fireMetrika({
                            sortParams: newSortParams
                        });
                    }

                    const oldFilters = selectGridFilterExpressionsForMetrika(oldState);
                    const newFilters = selectGridFilterExpressionsForMetrika(newState);

                    if (!isEqual(oldFilters, newFilters)) {
                        fireMetrika(newFilters);
                    }

                    const oldStatPeriodValue = selectStatPeriodValueForMetrika(oldState);
                    const newStatPeriodValue = selectStatPeriodValueForMetrika(newState);

                    if (oldStatPeriodValue && oldStatPeriodValue !== newStatPeriodValue) {
                        fireMetrika({
                            statPeriodValue: newStatPeriodValue
                        });
                    }

                    break;
                }

                default:
                    break;
            }

            break;
        }

        case OPEN_EDIT_CAMPAIGN_POPUP: {
            fireMetrika({
                openCampaignEditPopup: true
            });

            break;
        }

        case OPEN_EDIT_GROUPS_POPUP: {
            fireMetrika({
                openGroupEditPopup: true
            });

            break;
        }

        case SWITCH_TO_OLD_INTERFACE: {
            reachGoal('NEW_INTERFACE_BACK_TO_OLD');

            break;
        }

        case UPDATE_HEADER_INFO: {
            if ((newState.header.allowedMenuItems || []).includes(GdMenuItem.RECOMMENDATIONS)) {
                reachGoal('recommendations_ShowLink');
            }
            break;
        }
        case OPEN_GRID_SCREEN_RECOMMENDATIONS_POPUP: {
            fireMetrika({
                recommendationsPopup: {
                    opened: {
                        view: action.view
                    }
                }
            });

            const goal = {
                [campaigns]: 'recommendations_Popup_opened_campaigns',
                [groups]: 'recommendations_Popup_opened_groups',
                [banners]: 'recommendations_Popup_opened_banners'
            }[action.view];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        case FIRE_SHOW_GRID_SCREEN_RECOMMENDATION_EVENT: {
            fireMetrika({
                recommendationsPopup: {
                    showRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            break;
        }

        // нажатие кнопки Отправить гарантийное письмо на гриде баннеров
        case FIRE_GRID_SCREEN_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT: {
            fireMetrika({
                recommendationsPopup: {
                    sendLicenceButtonClick: true
                }
            });

            reachGoal('recommendations_Popup_sendLicenceButtonClick');

            break;
        }

        // нажатие кнопки применить рекомендации на дашборде
        case SUBMIT_GRID_SCREEN_RECOMMENDATION_ITEM: {
            fireMetrika({
                recommendationsPopup: {
                    submittedRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]: 'recommendations_Page_SubmittedRecommendation_DailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_Page_SubmittedRecommendation_RemovePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_Page_SubmittedRecommendation_SwitchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // открытие дашборда рекомендаций
        case OPEN_RECOMMENDATIONS_SCREEN: {
            fireMetrika({
                recommendationsPage: {
                    opened: true
                }
            });

            reachGoal('recommendations_Page_opened');

            break;
        }

        case NO_RECOMMENDATIONS_ERROR_SHOWN: {
            fireMetrika({
                recommendationsPage: {
                    empty: true
                }
            });

            reachGoal('recommendations_Page_empty');
            break;
        }

        // показ типа рекомендации на странице списка рекомендаций
        case FIRE_SHOW_RECOMMENDATION_CARD_EVENT: {
            fireMetrika({
                recommendationsPage: {
                    showRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]: 'recommendations_Page_dailyBudget',
                [RecommendationType.removePagesFromBlackList]: 'recommendations_Page_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]: 'recommendations_Page_switchOnAutotargeting',
                [RecommendationType.changeAdGroupForModeration]: 'recommendations_Page_moderation',
                [RecommendationType.changeBannerForModeration]: 'recommendations_Page_moderation',
                [RecommendationType.sendLicenses]: 'recommendations_Page_guarantee',
                [RecommendationType.changeAdGroupWithLowStat]: 'recommendations_Page_rarelyServed'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки применить на гриде кампаний, баннеров, фраз
        case SUBMIT_RECOMMENDATION_CARD: {
            fireMetrika({
                recommendationsPage: {
                    submittedRecommendation: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]: 'recommendations_Popup_submittedRecommendation_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_Popup_submittedRecommendation_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_Popup_submittedRecommendation_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки Отправить гарантийное письмо на дашборде
        case FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT: {
            fireMetrika({
                recommendationsPage: {
                    sendLicenceButtonClick: true
                }
            });

            reachGoal('recommendationsPageSendLicenceButtonClick');

            break;
        }

        // переход на страничку с детализацией рекомендации
        case OPEN_RECOMMENDATIONS_GRID_PAGE: {
            fireMetrika({
                recommendationsGridPage: {
                    opened: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]: 'recommendations_GridPage_dailyBudget',
                [RecommendationType.removePagesFromBlackList]: 'recommendations_GridPage_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]: 'recommendations_GridPage_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки применить cтраничке с детализацией рекомендации суммарно по таблице
        case SUBMIT_RECOMMENDATIONS_GRID_SUMMARY: {
            fireMetrika({
                recommendationsGridPage: {
                    submittedSummary: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]: 'recommendations_GridPage_submittedSummary_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_GridPage_submittedSummary_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_GridPage_submittedSummary_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // нажатие кнопки применить cтраничке с детализацией рекомендации на элемент таблицы
        case SUBMIT_RECOMMENDATIONS_GRID_DATA_ITEM: {
            fireMetrika({
                recommendationsGridPage: {
                    submittedGridItem: {
                        type: action.recommendationType
                    }
                }
            });

            const goal = {
                [RecommendationType.dailyBudget]: 'recommendations_GridPage_submittedGridItem_dailyBudget',
                [RecommendationType.removePagesFromBlackList]:
                    'recommendations_GridPage_submittedGridItem_removePagesFromBlackList',
                [RecommendationType.switchOnAutotargeting]:
                    'recommendations_GridPage_submittedGridItem_switchOnAutotargeting'
            }[action.recommendationType];

            if (goal) {
                reachGoal(goal);
            }

            break;
        }

        // welcome page
        case BASE_USER_SETTINGS_SUBMITTED_METRIKA: {
            const { baseSettings } = oldState.welcome;

            metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'PAGE_EMAIL', {
                yandexuid: getYandexUidCookie()
            });
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_191494, 'NEWLOGIN');

            if (baseSettings.email) {
                metrikaApi.reachGoal(MetrikaCounter.COUNTER_191494, 'SET_EMAIL');
            }

            switch (baseSettings.country) {
                case RegionCode.RUSSIA:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CHOOSE_RUSSIA');
                    break;
                case RegionCode.BELORUSSIA:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CHOOSE_BEL');
                    break;
                case RegionCode.KAZAKHSTAN:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CHOOSE_KAZ');
                    break;
                default:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CHOOSE_DRUGIE');
                    break;
            }

            break;
        }

        case CREATE_FIRST_CAMPAIGN: {
            if (action.campType === CampaignType.TEXT) {
                metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'FIRST_CAMP_TEXT');
            } else {
                metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'FIRST_CAMP_NO_TEXT');
            }
            break;
        }

        case WELCOME_BANNER_IS_SHOWN: {
            switch (action.bannerType) {
                case WelcomeBannerType.YANDEX:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'SHOW_YANDEX_BANNER');
                    break;
                case WelcomeBannerType.AGENCY:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'SHOW_AGENCY_BANNER');
                    break;
                case WelcomeBannerType.FREELANCER:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'SHOW_FREELANCER_BANNER');
                    break;
                default:
                    break;
            }
            break;
        }

        case WELCOME_BANNER_IS_CLICKED: {
            switch (action.bannerType) {
                case WelcomeBannerType.YANDEX:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CLICK_YANDEX_BANNER');
                    break;
                case WelcomeBannerType.AGENCY:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CLICK_AGENCY_BANNER');
                    break;
                case WelcomeBannerType.FREELANCER:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'CLICK_FREELANCER_BANNER');
                    break;
                default:
                    break;
            }
            break;
        }

        case SHOW_FREELANCER_CONTACTS:
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_49312303, 'KARTA', {
                URL: document.location.href
            });
            break;

        case ACKNOWLEDGE_USER_STAYED_ON_CARD:
            const { authorizationData } = oldState.commonData;
            const freelancerLogin = oldState.router.params && oldState.router.params.freelancerLogin;

            if (authorizationData) {
                if (authorizationData.isFreelancer && freelancerLogin !== authorizationData.login) {
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'ACKNOWLEDGE_FREELANCER_STAYED_ON_CARD', {
                        URL_30_sec: document.location.href
                    });
                }

                if (!authorizationData.isFreelancer) {
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'ACKNOWLEDGE_CUSTOMER_STAYED_ON_CARD', {
                        URL_30_sec: document.location.href
                    });
                }
            }

            break;

        case FREELANCER_INFO_PANEL_CLICKED:
            switch (action.clickType) {
                case FreelancerInfoPanelClickTypes.FREELANCER:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'FREELANCER_INFO_PANEL_CLICK_ON_FREELANCER', {
                        URL_click_on_freelancer: document.location.href
                    });
                    break;
                case FreelancerInfoPanelClickTypes.MY_PROFILE:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'FREELANCER_INFO_PANEL_CLICK_ON_MY_PROFILE', {
                        URL_click_on_my_profile: document.location.href
                    });
                    break;
                case FreelancerInfoPanelClickTypes.MY_CUSTOMERS:
                    metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'FREELANCER_INFO_PANEL_CLICK_ON_MY_CUSTOMERS', {
                        URL_click_on_my_customers: document.location.href
                    });
                    break;
                case FreelancerInfoPanelClickTypes.ALL_SPECIALISTS_BY_FREELANCER:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_ALL_SPECIALISTS_BY_FREELANCER',
                        {
                            URL_click_on_all_specialists_by_freelancer: document.location.href
                        }
                    );
                    break;
                case FreelancerInfoPanelClickTypes.ALL_SPECIALISTS_BY_CUSTOMER:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_ALL_SPECIALISTS_BY_CUSTOMER',
                        {
                            URL_click_on_all_specialists_by_customer: document.location.href
                        }
                    );
                    break;
                case FreelancerInfoPanelClickTypes.BECOME_SPECIALIST:
                    metrikaApi.reachGoal(
                        MetrikaCounter.COUNTER_34,
                        'FREELANCER_INFO_PANEL_CLICK_ON_BECOME_SPECIALIST',
                        {
                            URL_click_on_become_specialist: document.location.href
                        }
                    );
                    break;
                default:
                    break;
            }
            break;

        case ADD_FREELANCER_FEEDBACK_START:
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'FREELANCER_ADD_FEEDBACK', {
                URL_dobavit_otzyv: document.location.href
            });
            break;

        case REQUEST_COOP_BY_CUSTOMER_START:
            reachGoal('FREELANCER_GIVE_ACCESS', {
                URL_dostyp: document.location.href,
                yandexuid: getYandexUidCookie()
            });
            break;

        case OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT:
            reachGoal('FREELANCER_START_COOP', {
                URL_sotrydnichat: document.location.href,
                yandexuid: getYandexUidCookie()
            });
            break;

        case OPEN_FREELANCER_FEEDBACK_FORM:
            if (
                action.mode === FreelancerFeedbackFormModes.ADD_NEW_FEEDBACK ||
                action.mode === FreelancerFeedbackFormModes.EDIT_FEEDBACK
            ) {
                metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'FREELANCER_FEEDBACK_POPUP_OPEN', {
                    URL_ostavit_otzyv: document.location.href
                });
            }
            break;

        case OPEN_DEAL_INSPECTOR:
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'DEAL_CONDITIONS');
            break;

        case ACCEPT_REJECT_DEALS:
            if (action.updateObject) {
                getChangeDataDealMetrikaCounter(action.updateObject);
            }

            action.isAccept
                ? metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'APPROVE_DEAL')
                : metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, 'REJECT_DEAL');
            break;

        case UPDATE_DEALS:
            getChangeDataDealMetrikaCounter(action.updateObject);
            break;
        case COPY_PREV_BANNER:
            fireBannersEditMetrika({
                copyPrevBanner: true
            });

            break;
        case COPY_BANNER:
            fireBannersEditMetrika({
                copyBanner: true
            });

            break;
        case OPEN_MASS_ACTIONS_BANNERS_PRICE:
            fireBannersEditMetrika({
                bannersMassActions: {
                    bannerPrice: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE:
            fireBannersEditMetrika({
                bannersMassActions: {
                    bannerPrice: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkReplacement: {
                        open: true
                    }
                }
            });

            break;
        case SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageCreativeReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ACCEPT_MASS_ACTIONS_BULK_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageCreativeReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpmImageCreativeBulkReplacementEditorVisible: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpmImageCreativeBulkReplacementEditorVisible: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_OPEN_MASS_ACTIONS_PIXEL:
            fireBannersEditMetrika({
                bannersMassActions: {
                    pixelEditorVisible: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    pixelEditorVisible: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    countersEditorVisible: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_OPEN_MASS_ACTIONS_COUNTERS:
            fireBannersEditMetrika({
                bannersMassActions: {
                    countersEditorVisible: {
                        open: true
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpcVideoReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_VIDEO_CREATIVE_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    cpcVideoReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkPathReplacement: {
                        open: true
                    }
                }
            });

            break;
        case SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkPathReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkDisplayedReplacement: {
                        open: true
                    }
                }
            });

            break;
        case OPEN_TURBOLANDINGS_CONSTRUCTOR:
            const { payload } = action;

            if (!payload || !payload.creationMode) {
                return;
            }

            fireBannersEditMetrika({
                turbolandingConstructor: {
                    [turbolandingConstructorCreationModeMap[payload.creationMode]]: {
                        open: true
                    }
                }
            });

            break;
        case OPEN_EDIT_TURBOLANDINGS_CONSTRUCTOR_METRIKA:
            fireBannersEditMetrika({
                turbolandingConstructor: {
                    edit: true
                }
            });

            break;
        case UPDATE_TURBOLANDING:
            fireBannersEditMetrika({
                turbolandingConstructor: {
                    updated: true
                }
            });

            break;
        case ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    linkDisplayedReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    videoReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_VIDEO_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    videoReplacementAccept: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    turbolandingReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    turbolandingReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    trackingParametersReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    trackingParametersReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case ON_OPEN_MASS_ACTIONS_CALLOUTS:
            fireBannersEditMetrika({
                bannersMassActions: {
                    callouts: {
                        open: true
                    }
                }
            });

            break;
        case ACCEPT_MASS_ACTIONS_CALLOUTS:
            fireBannersEditMetrika({
                bannersMassActions: {
                    callouts: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });
            break;
        case ON_OPEN_MASS_ACTIONS_SITE_LINKS_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    siteLinks: {
                        open: true
                    }
                }
            });
            break;
        case ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    siteLinks: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageReplacement: {
                        open: true
                    }
                }
            });

            break;
        case ON_ACCEPT_BULK_IMAGE_REPLACEMENT:
            fireBannersEditMetrika({
                bannersMassActions: {
                    imageReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case OPEN_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    textReplacement: {
                        open: true
                    }
                }
            });

            break;
        case SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR:
            fireBannersEditMetrika({
                bannersMassActions: {
                    textReplacement: {
                        accept: true,
                        count: Object.keys(newState.editBanners.banners).length
                    }
                }
            });

            break;
        case FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT:
            reachGoal('ACKNOWLEDGE_USER_FROM_CARD', {
                yandexuid: getYandexUidCookie()
            });

            break;
        case FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE:
            reachGoal('LOGGEDIN_USER_FROM_CARD', {
                yandexuid: getYandexUidCookie()
            });

            break;

        case FIRE_COMMON_WALLET_CLICK:
            reachGoal('COMMON_WALLET_CLICK', {
                URL_common_wallet_click: document.location.href
            });
            break;

        case PROCESS_SIDEBAR_CLICK: {
            fireSidebarAction(action);
            break;
        }

        case TOGGLE_COMPACT_VIEW: {
            const isCompactViewEnabled = selectGridCompactViewForMetrika(newState);
            fireCompactViewAction(isCompactViewEnabled);
            break;
        }

        case DAILY_BUDGET_OPERATIONS_METRIKA: {
            reachGoal(action.payload.goal, action.payload.params);
            break;
        }

        case PHRASES_SELECTOR_OPEN_EDITOR:
            const { wizardId } = action;

            switch (wizardId) {
                case PhrasesSelectorWizardId.editGroupsPage:
                    reachGoal('KEYWORD_ADVISER_OPEN_FROM_GROUP');
                    break;
                case PhrasesSelectorWizardId.groupsGrid:
                    reachGoal('KEYWORD_ADVISER_OPEN_FROM_GRID');
                    break;
                case PhrasesSelectorWizardId.sideBar:
                    reachGoal('KEYWORD_ADVISER_OPEN_FROM_SIDEBAR');
                    break;
                default:
                    break;
            }
            break;

        case PHRASES_SELECTOR_SAVE_PHRASES:
        case SAVE_PHRASES_SELECTOR_PHRASES:
            reachGoal('KEYWORD_ADVISER_SAVE_KEYWORDS_TO_GROUP');
            break;
        case PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT:
            reachGoal('KEYWORD_ADVISER_ADD_KEYWORDS_MANUALLY');
            break;
        case PHRASES_GENERATOR_GENERATE_PHRASES:
            reachGoal('KEYWORD_ADVISER_ADD_KEYWORDS_FROM_COMBINATOR');
            break;
        case PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA:
            reachGoal('KEYWORD_ADVISER_DETAIL_KEYWORD_OPEN');
            break;
        case PHRASES_SELECTOR_REFINE_KEYWORD:
            reachGoal('KEYWORD_ADVISER_DETAIL_KEYWORD_COMMIT');
            break;
        case PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA:
            reachGoal('KEYWORD_ADVISER_MINUS_SELECTED_WORD');
            break;
        case PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA:
            reachGoal('KEYWORD_ADVISER_MINUS_WHOLE_PHRASE');
            break;
        case PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA:
            reachGoal('KEYWORD_ADVISER_MINUS_INPUT');
            break;
        case PHRASES_SELECTOR_KEYWORD_ADD_METRICA:
            reachGoal('KEYWORD_ADVISER_SELECT_ONE');
            break;
        case PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA:
            reachGoal('KEYWORD_ADVISER_SELECT_MASS');
            break;
        case PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA:
            reachGoal('KEYWORD_ADVISER_DELETE_MASS');
            break;
        case PHRASES_SELECTOR_CLEAR_KEYWORDS:
            reachGoal('KEYWORD_ADVISER_CLEAR_SELECTED_LIST');
            break;
        case PHRASES_SELECTOR_CLEAR_MINUS_PHRASES:
            reachGoal('KEYWORD_ADVISER_CLEAR_MINUS_LIST');
            break;
        case KeywordsEditorActionType.SWITCH_TAB:
            if (action.tabIndex === KeywordsEditorDataTabs.FORECAST_TAB) {
                reachGoal('GROUP_EDIT_OPEN_KEYWORD_FORECAST_TAB');
            }
            break;
        case KeywordsEditorActionType.SET_REFINE_KEYWORD_INDEX:
            reachGoal('GROUP_EDIT_DETAIL_KEYWORD_OPEN');
            break;
        case KeywordsEditorActionType.REFINE_KEYWORD:
            reachGoal('GROUP_EDIT_DETAIL_KEYWORD_COMMIT');
            break;
        case KeywordsEditorActionType.DELETE_KEYWORD:
            reachGoal('GROUP_EDIT_KEYWORD_DELETE');
            break;

        case OPEN_PHRASES_SELECTOR_WIZARD: {
            switch (action.wizardId) {
                case PhrasesSelectorWizardId.sideBar:
                    reachGoal('OLD_KEYWORD_ADVISER_OPEN_FROM_SIDEBAR');
                    break;
                case PhrasesSelectorWizardId.groupsGrid:
                    reachGoal('OLD_KEYWORD_ADVISER_OPEN_FROM_GRID');
                    break;
                case PhrasesSelectorWizardId.editGroupsPage:
                    reachGoal('OLD_KEYWORD_ADVISER_OPEN_FROM_GROUP');
                    break;
                default:
                    break;
            }
            break;
        }
        case GET_DEFAULT_CAMPAIGNS_FOR_EDIT: {
            const { isDefaultAutobudgetAvgCpaEnabled = false } = newState.commonData.features;

            reachGoal('DIRECT-107790-session-started', {
                isDefaultAutobudgetAvgCpaFeatureEnabled: isDefaultAutobudgetAvgCpaEnabled
            });
            break;
        }
        case SEND_CREATE_CAMPAIGN_METRIKA_EVENT: {
            fireMetrikaOnCreateCampaignEvent(action.campaignData);
            break;
        }
        case TOOL_CLICK_METRIKA: {
            fireToolsMetrika(action.toolKey);
            break;
        }
        default: {
            return;
        }
    }
};

const processCanvasActions = (oldState: State, newState: State, action: Action): void => {
    switch (action.type) {
        case OPEN_CREATIVE_HTML5_CONSTRUCTOR:
            fireBannersEditMetrika({
                html5Constructor: {
                    open: true,
                    page: CanvasPageType.html5,
                    productType: action.sharedData.productType
                }
            });

            break;
        case OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR:
            fireBannersEditMetrika({
                html5Constructor: {
                    open: true,
                    page: CanvasPageType.html5Add,
                    productType: action.sharedData.productType
                }
            });

            break;

        case OPEN_CREATIVE_CONSTRUCTOR:
            fireBannersEditMetrika({
                creativeConstructor: {
                    open: true,
                    page: CanvasPageType.creatives
                }
            });

            break;
        case OPEN_CREATIVE_CONSTRUCTOR_PRESETS:
            fireBannersEditMetrika({
                creativeConstructor: {
                    open: true,
                    page: CanvasPageType.presets
                }
            });

            break;
        case OPEN_CREATIVE_IDEAS:
            fireBannersEditMetrika({
                creativeConstructor: {
                    open: true,
                    page: CanvasPageType.ideas
                }
            });

            break;
        case UPDATE_BANNER_CREATIVE_ID:
            if (action.isHtml5) {
                fireBannersEditMetrika({
                    html5Constructor: {
                        update: true,
                        count: action.ids.length
                    }
                });
            } else {
                fireBannersEditMetrika({
                    creativeConstructor: {
                        update: true,
                        count: action.ids.length
                    }
                });
            }

            break;
        case OPEN_VIDEO_CONSTRUCTOR:
            fireBannersEditMetrika({
                videoConstructor: {
                    open: true
                }
            });

            break;
        case UPDATE_BANNER_VIDEO_CREATIVE_ID:
            fireBannersEditMetrika({
                videoConstructor: {
                    update: true
                }
            });

            break;
        case SHOW_BANNER_IMAGE_CANVAS:
            fireBannersEditMetrika({
                imageCanvas: {
                    open: true,
                    page: action.canvasType
                }
            });

            break;
        case SELECT_IMAGE_CANVAS_IDS:
            fireBannersEditMetrika({
                imageCanvas: {
                    update: true,
                    count: action.ids.length
                }
            });

            break;
        case OPEN_VIDEO_CONSTRUCTOR_WITH_CPC_VIDEO:
            fireBannersEditMetrika({
                videoConstructor: {
                    open: true,
                    cpc: true
                }
            });

            break;
        case UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID:
            fireBannersEditMetrika({
                videoConstructor: {
                    update: true,
                    cpc: true
                }
            });

            break;
        default:
            break;
    }
};

const processModerationMessageActions = (oldState: State, newState: State, action: Action): void => {
    switch (action.type) {
        case getType(showModerationMessage):
            fireCampaignsEditMetrika({
                moderationMessage: {
                    open: true
                }
            });

            break;

        case getType(confirmModerationMessage):
            fireCampaignsEditMetrika({
                moderationMessage: {
                    confirm: true
                }
            });

            break;

        case getType(cancelModerationMessage):
            fireCampaignsEditMetrika({
                moderationMessage: {
                    cancel: true
                }
            });

            break;

        default:
            break;
    }
};
